'use client'

import React, { FC, ReactElement } from 'react'
import styles from './SuccessModal.module.css'
import CheckmarkCircleIcon from '@/icons/checkmark-circle'
import Modal from '@/components/modal'
import Wallet from '@/utils/wallet'
import classNames from 'classnames'
import JoinDiscordButton from '@/components/join-discord-button'
import TweetIntentButton from '@/components/tweet-intent-button'
import { Inscription } from '@/utils/types/inscription'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const SuccessModal: FC<{ open: boolean; onClose: (evt: any) => void; inscription: Inscription }> = (
	props
): ReactElement => {
	const address = Wallet.getTaprootAddress()

	return (
		<Modal open={props.open} onClose={props.onClose}>
			<div
				className={styles.root}
				onClick={props.onClose}
				role="button"
				tabIndex={0}
				onKeyDown={onKeyboardClick(props.onClose)}
			>
				<CheckmarkCircleIcon className={styles.icon} />
				<p className={classNames(styles.title, 'text-lg', 'semibold')}>.Name set!</p>
				<p className={classNames(styles.description, 'text-sm', 'regular')}>
					Celebrate by sharing it to Twitter 🥳
				</p>
				<div className={styles.buttons}>
					<TweetIntentButton
						buttonClassName={styles.button}
						intent={`I just set my .Name on @ordinalswallet!\n\nYou can now send money directly to ${props?.inscription?.meta?.name} !!!\n\nSet yours here 👇 https://ordinalswallet.com/address/${address}`}
						iconClassName={styles.twitterIcon}
					/>
					<JoinDiscordButton buttonClassName={styles.discord} iconClassName={styles.discordIcon} />
				</div>
			</div>
		</Modal>
	)
}

export default SuccessModal
